import { InjectionToken } from '@angular/core';

/**
 * Authored brand theme tokens injected by each brand's `provide*BrandConfig`.
 *
 * Shared libs stay brand-agnostic: the store applies these once on init and
 * never exposes a runtime rainbow picker. Multi-brand re-skin is token-only.
 */
export type ThemeBrandTokens = {
  /**
   * Cool-steel surface ramp applied via `updateSurfacePalette` (includes `0`).
   */
  instrument: Record<string, string>;
  /**
   * Action / primary ramp registered under {@link primaryName} in
   * {@link THEME_BRAND_PALETTES}.
   */
  primary: Record<string, string>;
  /** Key used as `ThemeState.primaryColor` (e.g. `'indutrust'`, `'brand-a'`). */
  primaryName: string;
};

/**
 * Optional authored brand theme. Defaults to empty so shared libs boot without
 * a brand layer (tests); production apps must provide a full set.
 */
export const THEME_BRAND_TOKENS = new InjectionToken<ThemeBrandTokens | null>(
  'THEME_BRAND_TOKENS',
  { factory: () => null }
);
